/// <reference path="./global.d.ts" />
/// <reference path="./signalR/index.d.ts" />

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import Rollbar from './Rollbar';
import './configGlobal';

ReactDOM.render(
    (
        <Rollbar>
            <Provider store={store}>
                <App />
            </Provider>
        </Rollbar>
    ),
    document.getElementById('root'),
);
